const axios = require("axios");

class Http {
    get(url, pathParams) {
        return this.send({
            url: url,
            method: "get",
            pathParams: pathParams
        });
    }

    post(url, data, pathParams) {
        return this.send({
            url: url,
            method: "post",
            pathParams: pathParams,
            data: data
        });
    }

    put(url, data, pathParams) {
        return this.send({
            url: url,
            method: "put",
            pathParams: pathParams,
            data: data
        });
    }

    delete(url, pathParams) {
        return this.send({
            url: url,
            method: "delete",
            pathParams: pathParams
        });
    }

    /**
     *
     * @param options
     * @param options.url
     * @param options.method
     * @param options.pathParams
     * @param options.data
     * @param options.authToken
     * @returns {*|AxiosPromise<any>}
     */
    send(options) {
        return axios({
            baseURL: process.env.VUE_APP_BASE_URL,
            url: options.url,
            method: options.method,
            timeout: 20000,
            headers: {
                "Content-Type": "application/json;charset=UTF-8"
            },
            params: options.pathParams,
            data: options.data,
            responseType: 'json',
            responseEncoding: 'utf8'
        }).then(resp => resp.data).catch(e => {
            console.error(e.response.data);
            throw e.response.data;
        });
    }
}

export default new Http();